module.exports = __webpack_public_path__ + "static/media/cross-bracelet_720x480.2110fd85.jpg";